import { _Vue } from '../index';
import createWatcher from './watcher';
import { arrayFind } from '../../../utils/util';

export default function createWrappedWatcher() {
  const Watcher = createWatcher();

  Watcher.prototype.mutations = {
    setData(states, data) {
      const dataInstanceChanged = states._data !== data;
      states._data = data;

      this.execQuery();
      // 数据变化，更新部分数据。
      // 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
      this.updateCurrentRow();
      this.updateExpandRows();
      if (states.reserveSelection) {
        this.assertRowKey();
        this.updateSelectionByRowKey();
      } else {
        if (dataInstanceChanged) {
          this.clearSelection();
        } else {
          this.cleanSelection();
        }
      }
      this.updateAllSelected();

      this.updateTableScrollY();
    },

    insertColumn(states, column, index, parent) {
      let array = states._columns;
      if (parent) {
        array = parent.children;
        if (!array) array = parent.children = [];
      }

      if (typeof index !== 'undefined') {
        array.splice(index, 0, column);
      } else {
        array.push(column);
      }

      if (column.type === 'selection') {
        states.selectable = column.selectable;
        states.reserveSelection = column.reserveSelection;
      }

      if (this.table.$ready) {
        this.updateColumns(); // hack for dynamics insert column
        this.scheduleLayout();
      }
    },

    removeColumn(states, column, parent) {
      let array = states._columns;
      if (parent) {
        array = parent.children;
        if (!array) array = parent.children = [];
      }
      if (array) {
        array.splice(array.indexOf(column), 1);
      }

      if (this.table.$ready) {
        this.updateColumns(); // hack for dynamics remove column
        this.scheduleLayout();
      }
    },

    hideColumn(states, prop) {
      states._columns.some((column) => {
        if (column.property === prop) {
          column.needDisplay = false;
          return true;
        }
      });
      if (this.table.$ready) {
        this.updateColumns();
        this.scheduleLayout();
      }
    },

    updateMovableColumn(states, movableList) {
      if (!movableList || !movableList.length) {
        return;
      }
      const array = [];
      const _columns = states._columns;
      const ignore = this.table.initDisplayedColumn.ignore;
      _columns.forEach((column) => {
        if (column.type === 'selection' || column.type === 'expand' || column.type === 'index' || column.fixed || (ignore && ignore.indexOf(column.property) > -1)) {
          array.push(column);
        }
      });
      movableList.forEach((item) => {
        array.push(_columns.find((column) => {
          return column.property === item.label;
        }));
      });

      states._columns = array;
      if (this.table.$ready) {
        this.updateColumns();
        this.scheduleLayout();
      }
    },

    showColumn(states, prop) {
      states._columns.some((column) => {
        if (column.property === prop) {
          column.needDisplay = true;
          return true;
        }
      });
      if (this.table.$ready) {
        this.updateColumns();
        this.scheduleLayout();
      }
    },

    sort(states, options) {
      const { prop, order, init } = options;
      if (prop) {
        const column = arrayFind(states.columns, column => column.property === prop);
        if (column) {
          column.order = order;
          this.updateSort(column, prop, order);
          this.commit('changeSortCondition', { init });
        }
      }
    },

    changeSortCondition(states, options) {
      // 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
      const { sortingColumn: column, sortProp: prop, sortOrder: order } = states;
      if (order === null) {
        states.sortingColumn = null;
        states.sortProp = null;
      }
      const ingore = { filter: true };
      this.execQuery(ingore);

      if (!options || !(options.silent || options.init)) {
        this.table.$emit('sort-change', {
          column,
          prop,
          order
        });
      }

      this.updateTableScrollY();
    },

    filterChange(states, options) {
      let { column, values, silent } = options;
      const newFilters = this.updateFilters(column, values);

      this.execQuery();

      if (!silent) {
        this.table.$emit('filter-change', newFilters);
      }

      this.updateTableScrollY();
    },

    toggleAllSelection() {
      this.toggleAllSelection();
    },

    rowSelectedChanged(states, row) {
      this.toggleRowSelection(row);
      this.updateAllSelected();
    },

    setHoverRow(states, row) {
      states.hoverRow = row;
    },

    setCurrentRow(states, row) {
      this.updateCurrentRow(row);
    },

    updateFlip(states, flag) {
      states.flip = flag;
    }
  };

  Watcher.prototype.commit = function(name, ...args) {
    const mutations = this.mutations;
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args));
    } else {
      throw new Error(`Action not found: ${name}`);
    }
  };

  Watcher.prototype.updateTableScrollY = function() {
    _Vue.nextTick(this.table.updateScrollY);
  };

  return new Watcher();
}
